import React from 'react';
import Layout from '../../shared/components/Layout';
import { Link } from "react-router-dom";

const FacilityAgreementIndex: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <main id="page-facility_login" className="wrapper">
          <section className="sec-contact">
            <div className="inner">
              <h1 className="c-ttl__01">施設型定額制契約</h1>
            </div>
          </section>
          <div className="sec-link">
            <div className="inner">
              <ul className="link-list">
                <li className="link-list__item">
                  <Link to="/facility/facility_agreements/customers">お客様情報変更申込</Link>
                </li>
                <li className="link-list__item">
                  <Link to="/facility/facility_agreements/terminate_cancels">解約・キャンセル申込</Link>
                </li>
                <li className="link-list__item">
                  <Link to="/facility/facility_agreements/lost_non_warranty">紛失・保証外レンズ申込</Link>
                </li>
              </ul>
            </div>
          </div>
        </main>
      </Layout>
    </React.Fragment>
  )
}

export default FacilityAgreementIndex;
